// AdminRedirect — capa de compatibilidad para URLs antiguas del panel admin.
//
// La nueva estructura:
//   /admin                       → AdminPanel (panel completo, 12 tabs)
//   /admin?tab=X                 → AdminPanel con tab=X
//   /admin?tab=publicidad/content→ /profile (publicidad ahora vive en perfil)
//   /admin/settings/global       → /admin?tab=config (config es tab interno)
//   /admin/settings/personal     → /settings/account
//
// AdminContentRedirect intercepta ANTES de mostrar AdminPanel: si el ?tab= es
// uno que ya no existe en el panel (ej. publicidad), redirige a /profile.

import { Navigate, useSearchParams, useLocation } from 'react-router-dom';
import { tr } from '@/contexts/LanguageContext';

// Tabs que ya NO viven en el panel (`/admin`) y deben redirigir a /profile.
// NOTA: NO incluir 'content' aquí — colisiona con el tab nuevo de Moderación
// de Posts en AdminProfileView. El centro de campañas usa 'publicidad'.
const PROFILE_ONLY_TABS = new Set(['publicidad']);

// Remap de tabs antiguas a las nuevas dentro del panel
const PANEL_TAB_REMAP = {
  summary:      tr("resumen"),
  barbers:      'users',
  brands:       'users',
  posts:        'content',
  courses:      'marketplace',
  sponsorships: 'finance',
  payments:     'finance',
  commissions:  'finance',
  disputes:     'reports',
  votes:        'resumen'
};

export const AdminContentRedirect = ({ children }) => {
  const [params] = useSearchParams();
  const tab = params.get('tab');

  // Si el ?tab= apunta a publicidad (que ya no vive en el panel), redirige a /profile
  if (tab && PROFILE_ONLY_TABS.has(tab)) {
    return <Navigate to="/profile" replace />;
  }

  // Si el ?tab= es uno antiguo, remapeamos a la nueva tab del panel
  if (tab && PANEL_TAB_REMAP[tab]) {
    const remapped = PANEL_TAB_REMAP[tab];
    return <Navigate to={`/admin?tab=${remapped}`} replace />;
  }

  // Caso normal: render del panel admin
  return children;
};

export const AdminSettingsRedirect = () => {
  const location = useLocation();
  if (location.pathname === '/admin/settings/personal') {
    return <Navigate to="/settings/account" replace />;
  }
  return <Navigate to="/admin?tab=config" replace />;
};
